export default "__VITE_ASSET__b001d657__"